module.exports = __webpack_public_path__ + "img/submit-timesheet.72a46f73.svg";